import { combineReducers } from 'redux'

import messages from './messagesReducer'
import authentication from './authenticationJwtReducer'
import operationProgress from './operationProgressReducer'
import alertas from './alertasReducer'
import filtros from './filtrosReducer'
import unidadesUsuario from './unidadesUsuarioReducer'
import itens from './itensReducer'
import informacoesCarga from './informacoesCargaReducer'
import mainMenu from './mainMenuReducer'
import contextoWebSocket from './contextoWebSocketReducer'

const rootReducer = combineReducers({
  // Adicione reducers aqui...
  itens,
  unidadesUsuario,
  filtros,
  alertas,
  messages,
  authentication,
  operationProgress,
  informacoesCarga,
  mainMenu,
  contextoWebSocket
})

export default rootReducer
